import React from 'react';

const divStyle = {
  height: '2px',
  width: '85%',
  backgroundColor: 'black',
  marginBottom: '10px',
};

const HorizontalRule = () => {
  return <div data-aos="fade-up"style={divStyle}></div>;
};

export default HorizontalRule;
